import React from 'react';
import './SplitMethods.css';
import { ArrowsLeftRight, CirclesThreePlus, UsersThree, FireSimple } from '@phosphor-icons/react';

const METHODS = [
  {
    id: 'quick',
    label: 'Quick Pay & Collect',
    description: 'Send or request money instantly – perfect for quick paybacks, bar tabs, and everyday IOUs.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsplitmethod-1.png?alt=media&token=033ae498-213b-4f55-bae4-1331fead33f2',
    Icon: ArrowsLeftRight,
  },
  {
    id: 'fair',
    label: 'Fair & Degen Split',
    description:
      'Split bills equally, customize shares, or spin the wheel and let fate decide who pays this round.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsplitmethod-2.png?alt=media&token=d25a060e-fedf-43a3-9853-707da379dd17',
    Icon: CirclesThreePlus,
  },
  {
    id: 'squad',
    label: 'Squad Wallet Mode',
    description:
      'Pool funds into one shared wallet and spend together for trips, events, group buys, or DAOs.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsplitmethod-3.png?alt=media&token=44ae72e8-885f-4258-9e23-2fe4be4d6469',
    Icon: UsersThree,
  },
];

function SplitMethods() {
  return (
    <section id="splitmethods" className="splitmethods-section">
      <div className="splitmethods-wrapper">
        <header className="lp-section-header">
          <h2 className="lp-section-title">
            Every Group Is <span className="lp-section-title-highlight">Unique.</span>
            <br />
            Your Split Should Be Too.
          </h2>
          <p className="lp-section-subtitle">
            Choose how you split: fair, degen, flexible, or fully pooled. WeSplit adapts to your crew,
            your rules, your vibe.
          </p>
        </header>

        <div className="splitmethods-grid">
          {METHODS.map(({ id, label, description, image, Icon }) => (
            <article key={id} className="splitmethods-card">
              <div className="splitmethods-card-visual">
                <img src={image} alt={label} loading="lazy" />
              </div>
              <div className="splitmethods-card-body">
                <div className="splitmethods-card-label">
                  <span className="splitmethods-icon-pill">
                    <Icon weight="bold" size={18} />
                  </span>
                  <h3 className="lp-section-card-label-h3">{label}</h3>
                </div>
                <p className="lp-section-card-body-p">{description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="splitmethods-cta">
          <a
            href="#download"
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById('download');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="primary splitmethods-cta-btn"
          >
            <FireSimple weight="fill" size={20} className="splitmethods-cta-icon" />
            Start Splitting
          </a>
        </div>
      </div>
    </section>
  );
}

export default SplitMethods;


